const UniqeId = () => Date.now();

export default UniqeId;
